import DynamicFilter from "./dynamicFilter";

export const dynamicFilter = {
    init: () => {
        const resultContainer = document.querySelectorAll(".dynamicFilter");
        if (resultContainer != null) {
            [...resultContainer].forEach((result) => new DynamicFilter(result));
        }
    },
}

export default dynamicFilter;